import { useStore } from 'vuex';
import { getDeviceApi, getDashBoard, getDeviceInfo } from '@/api/devices';
import { demoDeviceInfo } from '@/components/nav/component/config/deviceInfo';
import { userInfo, userInfoDemo } from '@/api/login';
import store from '@/store/index';

const actions = {};

export default actions;
